import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * How much of the item price is VAT, for a verified business seller's sale.
 *
 * The figure is worked out once by the server when the order is placed and
 * stored in the transaction's protected data (server/api-util/vat.js), so the
 * breakdown, the receipt and the seller's email always show the same amount.
 * Private sellers' transactions carry no stamp and show nothing. Shown to both
 * parties, under the total, because it is part of the price, not added to it.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.transaction
 * @param {intlShape} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemVatMaybe = props => {
  const { transaction, intl } = props;
  const vat = transaction?.attributes?.protectedData?.vat;
  if (!vat || !Number.isInteger(vat.amount) || !vat.currency || !vat.rate) {
    return null;
  }
  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.vat" values={{ rate: vat.rate }} />
      </span>
      <span className={css.itemValue}>
        {formatMoney(intl, new Money(vat.amount, vat.currency))}
      </span>
    </div>
  );
};

export default LineItemVatMaybe;
